import { StyledLoading } from "./style";
import Logo from 'assets/logo.svg'





export const Loading = () => {


    return(

        <StyledLoading>

            <p>Carregando...</p>

        </StyledLoading>

    )
}